import { render, staticRenderFns } from "./ProcesosPendientes.vue?vue&type=template&id=f19094be&"
import script from "./ProcesosPendientes.vue?vue&type=script&lang=js&"
export * from "./ProcesosPendientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProcesosPendientes.vue"
export default component.exports